/* Offer bar above the header (snippets/minery-offer-bar.liquid).
   Rotate style: one message at a time, every 4.5s, with prev/next buttons.
   Pauses while hovered or focused, and never auto-advances when the
   visitor prefers reduced motion. The marquee style is pure CSS. */
(function () {
  var bar = document.querySelector('[data-m-offerbar]');
  if (!bar || bar.dataset.style === 'marquee' || bar.dataset.ready) return;
  bar.dataset.ready = '1';

  var msgs = Array.prototype.slice.call(bar.querySelectorAll('.m-offerbar__stage .m-offerbar__msg'));
  if (!msgs.length) return;

  var i = 0;
  var timer = null;
  var paused = false;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function show(n) {
    msgs[i].classList.remove('is-active');
    msgs[i].setAttribute('tabindex', '-1');
    i = (n + msgs.length) % msgs.length;
    msgs[i].classList.add('is-active');
    msgs[i].removeAttribute('tabindex');
  }

  function start() {
    if (reduce || msgs.length < 2) return;
    stop();
    timer = setInterval(function () { if (!paused) show(i + 1); }, 4500);
  }

  function stop() { if (timer) clearInterval(timer); timer = null; }

  msgs.forEach(function (m, k) {
    if (k === 0) m.classList.add('is-active');
    else m.setAttribute('tabindex', '-1');
  });

  bar.addEventListener('click', function (e) {
    var btn = e.target.closest('.m-offerbar__nav');
    if (!btn) return;
    show(i + Number(btn.dataset.dir));
    start();
  });
  bar.addEventListener('mouseenter', function () { paused = true; });
  bar.addEventListener('mouseleave', function () { paused = false; });
  bar.addEventListener('focusin', function () { paused = true; });
  bar.addEventListener('focusout', function () { paused = false; });
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) stop(); else start();
  });

  start();
})();
